var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGuaranteed = function SvgIconGuaranteed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.448 1.976 8.689.699a.57.57 0 0 0-.378 0L4.552 1.976C3.325 2.39 2.5 3.558 2.5 4.875V8c0 4.623 5.52 7.174 5.757 7.28.156.07.333.07.486 0C8.98 15.175 14.5 12.624 14.5 8V4.875c0-1.317-.825-2.484-2.052-2.9M13.3 8c0 3.333-3.792 5.52-4.8 6.043-1.011-.522-4.8-2.7-4.8-6.043V4.875c0-.788.495-1.49 1.23-1.738L8.5 1.924l3.57 1.213c.735.25 1.23.95 1.23 1.738z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.48 5.74 7.966 8.306l-1.347-1.43a.594.594 0 0 0-.849-.04.62.62 0 0 0-.039.865l.021.021L7.135 9.19c.21.229.501.36.807.366h.021c.3 0 .588-.122.801-.339l2.562-2.609a.62.62 0 0 0 0-.867.594.594 0 0 0-.852 0z"
  })));
};
export default SvgIconGuaranteed;